<script>
  import {localVideoLink} from "./services/localServices";
  export let video;
  const vid_element_id = 'local_video_element';
  const lang = 'en';

  export function set_player_time(settime) {
    let n = document.getElementById(vid_element_id);
    n.currentTime = settime;
    n.play();
  }
</script>

<video id={vid_element_id} width="100%" controls>
  <source src={ localVideoLink(video)} type="video/mp4" />
</video>
